import React, { useCallback, useEffect, useState } from "react";
import { EventLanguage } from "../../../utils/Languages";
import { useDropzone } from "react-dropzone";
import ImageGallery from "../ImageGallery";
import FileRejected from "../../Common/FileRejected";
import useHttpHook from "../../../Hooks/HttpHook";
import { RemoveImage } from "../../../utils/ApiConstant";
import { updEventData } from "../../../ReduxSlice/Event/eventSlice";
import { useDispatch } from "react-redux";
import InfiniteProgressBar from "../../Common/InfiniteProgressBar";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";
const FileInput = (props) => {
  const [files, setFiles] = useState([]);
  const [overlay, setOverlay] = useState(false);
  const eventData = props.EventData?.data;
  const rawFieldData = eventData?.[props.FieldName];
  const fieldData = Array.isArray(rawFieldData)
    ? rawFieldData
    : rawFieldData && typeof rawFieldData === "object"
    ? [rawFieldData]
    : [];
  const maximumFiles = Number(
    props.maxFiles ?? process.env.REACT_APP_MAX_UPLOAD_FILES
  );
  const isSingleFile = props.multiple === false || maximumFiles === 1;
  // Keep dropzone clickable; single-file fields replace the previous selection.
  const mainClsName = overlay === true ? "drap-disable disabled" : "drap-disable";

  const [loading, sendRequest, error] = useHttpHook();
  const dispatch = useDispatch();

  // New local files replace stored images for single-file fields (e.g. thumbnail).
  const galleryFieldData =
    isSingleFile && files.length > 0
      ? []
      : isSingleFile
      ? fieldData.slice(0, 1)
      : fieldData;

  // useEffect(() => {
  //   return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  // }, [files]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const {
    getRootProps,
    getInputProps,
    fileRejections,
    isDragActive,
    isDragReject,
    isDragAccept,
  } = useDropzone({
    maxFiles: isSingleFile ? 1 : maximumFiles,
    multiple: isSingleFile ? false : props.multiple,
    accept: {
      "image/*": [".jpg", ".jpeg", ".png"],
    },
    onFileDialogOpen: () => {
      setOverlay(true);
    },
    onFileDialogCancel: () => {
      setOverlay(false);
    },
    onDrop: (acceptedFiles) => {
      setOverlay(false);
      let filesList = acceptedFiles?.map((file) => {
        return Object.assign(file, {
          preview: URL.createObjectURL(file),
        });
      });

      if (isSingleFile) {
        const nextFiles = filesList.slice(0, 1);
        setFiles(nextFiles);
        props.setFieldValue(props.FieldName, nextFiles);
        return;
      }

      let filePath = filesList.map((singleFile) => {
        return singleFile.path;
      });

      let oldFiles = files.filter((file) => {
        if (!filePath.includes(file.path)) {
          return Object.assign(file, {
            preview: URL.createObjectURL(file),
          });
        }
      });

      let allFiles = [...oldFiles, ...filesList];
      if (Number.isFinite(maximumFiles) && maximumFiles > 0) {
        allFiles = allFiles.slice(0, maximumFiles);
      }

      setFiles(allFiles);
      props.setFieldValue(props.FieldName, allFiles);
    },
  });

  const fileRemoveHandler = useCallback(
    async (fileData, eventId) => {
      let filesList = files.filter((file) => {
        if (fileData.path != file.path) {
          return Object.assign(file, {
            preview: URL.createObjectURL(file),
          });
        }
      });

      setFiles(filesList);
      props.setFieldValue(props.FieldName, filesList);

      if (!fileData.preview) {
        let removeImage = await sendRequest(RemoveImage + eventId, {
          method: "post",
          data: {
            filename: fileData.filename,
            fieldData: props.FieldName,
          },
        });
        if (removeImage.status === 1) dispatch(updEventData(removeImage));
      }
    },
    [files]
  );

  return (
    <>
      {loading && <InfiniteProgressBar />}
      <div className="form-group">
        <div className="heading">
          <h4>{props.labelTitle}</h4>
          <p>{props.placeholder}</p>
        </div>
        <div className={mainClsName}>
          <div className="uploadStatic-container" {...getRootProps()}>
            <div className="dragDrop-content">
              <span>
                <svg
                  width="29"
                  height="24"
                  viewBox="0 0 29 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.5083 11.8657V22.7349"
                    stroke="#2AA8F2"
                    strokeWidth="1.81123"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M24.8012 19.5833C25.9981 18.9411 26.9436 17.925 27.4885 16.6953C28.0334 15.4655 28.1467 14.0922 27.8104 12.7921C27.4742 11.492 26.7075 10.3391 25.6315 9.51536C24.5555 8.69164 23.2315 8.24402 21.8682 8.24313H20.322C19.9506 6.82923 19.2583 5.51659 18.2972 4.4039C17.336 3.29121 16.1311 2.40743 14.7729 1.81899C13.4148 1.23056 11.9388 0.952781 10.4558 1.00655C8.97287 1.06032 7.52161 1.44424 6.21114 2.12944C4.90067 2.81463 3.76509 3.78328 2.88977 4.96256C2.01445 6.14184 1.42217 7.50105 1.15746 8.93803C0.892748 10.375 0.962494 11.8523 1.36145 13.259C1.76041 14.6656 2.4782 15.9649 3.46086 17.0592"
                    stroke="#2AA8F2"
                    strokeWidth="1.81123"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M19.4227 16.696L14.5141 11.8652L9.60547 16.696"
                    stroke="#2AA8F2"
                    strokeWidth="1.81123"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {isDragAccept && EventLanguage.EventForm.dragNDropAcceptedText}
                {isDragReject && EventLanguage.EventForm.dragNDropRejectedText}
                {!isDragActive && props.multiple
                  ? EventLanguage.EventForm.dragNDropTextMultiple
                  : EventLanguage.EventForm.dragNDropText}
              </span>
            </div>
            <div className="uploadStatic-btn">
              {/* <div className="uploadStatic-btn"> */}
              {/* <label type="button" className="btn"> */}
              <label>
                <input
                  {...getInputProps()}
                  name={props.FieldName}
                  type="file"
                  style={{ display: "none" }}
                />
                {/* Browse File/Folder */}
              </label>
            </div>
          </div>
          {overlay === true && <div className="disable-overlay"></div>}
        </div>

        <ImageGallery
          filesData={[files, galleryFieldData]}
          removeHandler={fileRemoveHandler}
          eventId={eventData?._id}
        />
        <FileRejected RejectedFiles={fileRejections} />
      </div>
    </>
  );
};

export default FileInput;
